/**
 * 转场特效 - tv-lottie(lottie动画)
 * 2018-10-8
 */

(function (root, factory) {
    if (typeof module === 'object' && typeof module.exports === 'object') {
        module.exports = factory(this);
    } else {
        factory(root);
    }
})(this, function (root) {

    var sceneEffectBox = {}; // 存储转场lottie动画信息，以便复用

    // 类构造函数
    function con(scene, option) {
        this.code = option.code || 'Clipboard';
        this.maskEle = null;
        this.lottie = null; // lottie控制对象
        this.lottieUrl = '';
    }

    var data = {
        initData: {
            Clipboard: [1.2, 0.8],
            Poof: [0.7, 0.15],
            SpiralzTech: [1.6, 0.7],
            Spiralz: [1.6, 0.7],
            Roller: [2.0, 1.3],
            Sqweegee: [1.8, 1.0],
            BlueColorSmear: [1.35, 0.7],
            WhiteColorSmear: [1.35, 0.7],
            Hands: [0.9, 0.45],
            PullDown: [1.0, 0.85, 0.7],
            FanDown: [1.2, 1, 0.2],
            FanUp: [1.2, 1, 0.2]
        }
    }

    var methods = {
        init: function(force) {
            var _this = this;
            var info = data.initData[this.code];
            // 不同lottie属性不一样
            this.duration = info[0];
            this.startAt = info[1];
            this.later = info[2] || 0; // 延后动画
            return this.supr(this.startAt, force).then(function () {
                _this.maskEle = sceneEffectBox[_this.code + _this.optimized + 'D'];
                _this.lottie = sceneEffectBox[_this.code + _this.optimized + 'L'];
            })
        },

        initDom: function() {
            // 初始化lottie DOM 结构
            if(!sceneEffectBox[this.code + this.optimized + 'D']) {
                var dom = sceneEffectBox[this.code + this.optimized + 'D'] = $('<div></div>').attr({id: 'mask_' + this.code + this.optimized});
                var _this = this,
                    editor = this.scene.editor;

                this.lottieUrl = '/static/animengine/js/scene-effects/lotties/' + this.code + (this.optimized === "Vertical" ? 'Vertical' : '') + '.json';

                // lottie容器optimized
                dom.attr({
                    'data-animation-path': this.lottieUrl,
                    'data-anim-type': 'svg',
                    'data-anim-autoplay': false,
                    'data-anim-loop': false,
                    'data-anim-prerender': true
                }).css(Object.assign({position: 'absolute'}, this.matrix)).hide();

                // lottie容器插入播放层的 maskEle 中
                editor.player.maskEle.append(dom)

                // instance 为lottie实例
                var instance = lottie.registerAnimation(dom[0]);
                dom = null;
                return new Promise(function(resolve) {
                    instance.addEventListener('DOMLoaded', function() {
                        sceneEffectBox[_this.code + _this.optimized + 'L'] = instance;
                        instance = null;
                        return resolve();
                    });
                })
            }
        },

        show: function (frame) {
            // 播放
            if (!this.isInit) return;
            this.supr(frame);

            var scene = this.scene,
                editor = scene.editor,
                sEle = scene.element.player; // player层的当前 scene

            // 播放层显示，对应scene显示
            editor.player.ele.show();
            sEle.show();

            // 衔接上一个场景页的动画(e.g.前0.5s的动画)
            if (frame <= this.entrance.end) {
                this.showFirst(frame)
            }

            // 本场景页的转场动画(e.g.后0.5s的动画)
            if (this.nexts && frame >= this.exit.start) {
                // 隐藏上一个场景页的遮罩
                this.prevs && this.prevs.effect.maskEle && this.prevs.effect.maskEle.hide();

                var nexts_ele = this.nexts.element.player; // player层中的下一个场景
                var offFrame = frame - this.exit.start; // 当前帧减去动画开始时的帧

                var h = this.scene.editor.clientHeight,
                    w = this.scene.editor.clientWidth;

                // 所有的lottie基本都是下面一样的控制
                this.maskEle && this.maskEle.show();
                this.lottie && this.lottie.setCurrentRawFrameValue(offFrame / this.frameRate * this.lottie.frameRate);

                nexts_ele.hide()

                var calcFrame = 0;  // 延后处理的帧

                switch(this.code) {
                    case 'PullDown':
                        calcFrame = offFrame - this.later * this.frameRate < 0 ? 0 : offFrame-this.later * this.frameRate;
                        // 下一个场景和Lottie一起下移
                        nexts_ele.css({ top: this.easeOutQuart(calcFrame, -h, h, this.totalFrame-this.later * this.frameRate), left: 0 }).show();
                        this.maskEle.css({top: this.easeOutQuart(calcFrame, 0, h, this.totalFrame-this.later * this.frameRate)})
                        break;
                    case 'FanUp':
                    case 'FanDown':
                        // 将整个遮罩层的zIndex调到当前和下个场景页中间
                        editor.player.maskEle.css({
                        zIndex: this.nexts.index * 5 - 2
                        })
                        calcFrame = offFrame - this.later * this.frameRate < 0 ? 0 : offFrame-this.later * this.frameRate;
                        // 下个场景页旋转的同时放大缩小(此处放大缩小用的二次函数顶点为1.25)
                        // FanDown将旋转点移动到右下角
                        nexts_ele.css({
                        transform: 'rotateZ('+ this.easeInOutSine(calcFrame, 90, -90, this.totalFrame-this.later * this.frameRate) +'deg) ' + 'scale('+ (offFrame/this.totalFrame - Math.pow(offFrame/this.totalFrame, 2) +1) +')',
                        transformOrigin: this.code === 'FanUp'? this.matrix.left+ 'px 0 0' : w - this.matrix.left +'px '+h+'px 0'
                        }).show()
                        break;
                }
            }

            // 动画外的时间(本场景页)
            if (frame > this.entrance.end && frame < this.exit.start) {
                this.showMiddle()
            }
        },

        // 为下一个场景提供方法以完成动画衔接
        showNext: function(frame) {
            if(!this.maskEle) return;
            // 到下一个场景页后，衔接的对应的帧
            var _currentFrame = this.startAt * this.frameRate + frame;
            // Lottie动画
            this.maskEle.show()
            this.lottie && this.lottie.setCurrentRawFrameValue(_currentFrame / this.frameRate * this.lottie.frameRate)

            var h = this.scene.editor.clientHeight,
                w = this.scene.editor.clientWidth;

            var next_ele = this.nexts.element.player;
            var sele = this.scene.element.player;

            switch(this.code) {
                case 'Hands':
                    // 当前场景和Lottie遮罩下移出场，下个场景下移入场
                    sele.css({ top: this.linear(frame, 0, h, this.totalFrame / 2), left: 0 });
                    next_ele.css({ top: this.linear(frame, -h, h, this.totalFrame / 2), left: 0 });
                    this.maskEle.css({top: this.linear(frame, 0, h, this.totalFrame / 2)})
                    break;
                case 'PullDown':
                    // 下个场景下移入场，Lottie遮罩下移出场
                    next_ele.css({ top: this.easeOutQuart(_currentFrame-this.later * this.frameRate, -h, h, this.totalFrame-this.later * this.frameRate), left: 0 });
                    this.maskEle.css({top: this.easeOutQuart(_currentFrame-this.later * this.frameRate, 0, h, this.totalFrame-this.later * this.frameRate)})
                    break;
                case 'FanUp':
                case 'FanDown':
                    this.scene.editor.player.maskEle.css({
                        zIndex: this.nexts.index * 5 - 2
                    })
                    next_ele.css({
                        transform: 'rotateZ('+ this.easeInOutSine(_currentFrame-this.later * this.frameRate, 90, -90, this.totalFrame-this.later * this.frameRate) +'deg) ' + 'scale('+ (_currentFrame/this.totalFrame - Math.pow(_currentFrame/this.totalFrame, 2) +1) +')',
                        transformOrigin: this.code === 'FanUp'? this.matrix.left+ 'px 0 0' : w - this.matrix.left +'px '+h+'px 0'
                    }).show()
                    break;
            }
        },
        // 缓动函数(具体参数查看 neweditor.js 的EasingAnim对象)
        easeInOutSine: function (t, b, c, d) {
            return -c/2 * (Math.cos(Math.PI*t/d) - 1) + b
        },

        // 清空DOM,以及一些没必要对象
        clearMask: function() {
            this.maskEle = null;
            this.lottie = null;
            this.isInit = false;
        }
    }

    // 静态方法
    var statics = {
    }

    if (root.AnimEditor) {
        root.AnimEditor.extendScenesEffect('lottie', con, methods, statics);
        return;
    }

    return function (AnimEditor) {
        AnimEditor.extendScenesEffect('lottie', con, methods, statics);
    }
});




//////////////////
// WEBPACK FOOTER
// ./static/animengine/js/scene-effects/se-lottie.js
// module id = /u6X
// module chunks = 16